import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54af9888")

_pushScopeId("data-v-54af9888")
const _hoisted_1 = {
  key: 0,
  class: "admin-contract-item admin-item"
}
const _hoisted_2 = { class: "type" }
const _hoisted_3 = { class: "status" }
const _hoisted_4 = { class: "company-name" }
const _hoisted_5 = { class: "plan" }
const _hoisted_6 = { class: "range" }
const _hoisted_7 = { class: "commands" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "ユーザー管理", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "編集", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "再開", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "停止", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "削除", -1)
const _hoisted_13 = { class: "notify" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    (!_ctx.isHeader)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("img", { src: _ctx.typeIcon }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode("img", { src: _ctx.statusIcon }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("span", null, _toDisplayString(_ctx.item.companyName), 1),
            _createVNode("span", null, _toDisplayString(_ctx.item.optionName), 1)
          ]),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.item.plan), 1),
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.yyyyMMdd(_ctx.fromUnixTime(_ctx.item.signed))) + " 〜 " + _toDisplayString(_ctx.yyyyMMdd(_ctx.fromUnixTime(_ctx.item.expire))), 1),
          _createVNode("div", _hoisted_7, [
            _createVNode("button", {
              class: "primary-button btn-l",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.context.emit('users', _ctx.item))),
              disabled: _ctx.isDisabled
            }, [
              _hoisted_8
            ], 8, ["disabled"]),
            (!_ctx.isDisabled)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "primary-button btn-m",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.context.emit('edit', _ctx.item))),
                  disabled: _ctx.isDisabled
                }, [
                  _hoisted_9
                ], 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.isDisabled)
              ? (_openBlock(), _createBlock("button", {
                  key: 1,
                  class: "primary-button btn-m",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.context.emit('restart', _ctx.item))),
                  disabled: !_ctx.isDisabled
                }, [
                  _hoisted_10
                ], 8, ["disabled"]))
              : _createCommentVNode("", true),
            (!_ctx.isDisabled)
              ? (_openBlock(), _createBlock("button", {
                  key: 2,
                  class: "danger-button btn-m",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.context.emit('stop', _ctx.item)))
                }, [
                  _hoisted_11
                ]))
              : _createCommentVNode("", true),
            (_ctx.isDisabled)
              ? (_openBlock(), _createBlock("button", {
                  key: 3,
                  class: "danger-button btn-m",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.context.emit('delete', _ctx.item)))
                }, [
                  _hoisted_12
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_13, [
            (_ctx.isDisabled)
              ? (_openBlock(), _createBlock("span", _hoisted_14, "利用停止状態になっています。"))
              : _createCommentVNode("", true),
            (!_ctx.isDisabled && _ctx.isExpired)
              ? (_openBlock(), _createBlock("span", _hoisted_15, "契約期限が過ぎています。更新手続きか停止手続きをしてください。"))
              : _createCommentVNode("", true),
            (!_ctx.isDisabled && !_ctx.isExpired && _ctx.isNearExpired)
              ? (_openBlock(), _createBlock("span", _hoisted_16, "1か月以内に契約更新期限を迎えます。"))
              : _createCommentVNode("", true),
            (!_ctx.isDisabled && _ctx.isPermanentFalse)
              ? (_openBlock(), _createBlock("span", _hoisted_17, "ユーザーアカウント数が超過しています。"))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})